module.exports = __webpack_public_path__ + "static/media/Huis-1-maps.66da790b.jpg";